import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingTop: '8%',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    marginBottom: 2,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 80,
    marginTop: 20,
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    padding: '10px',
    height: '30%'
  },
  contentContainer1: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    border: '1px solid black',
    padding: '10px',
    height: '30%'
  },
  contentContainer3: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 20,
    borderTop: '1px solid black'
  },
  column: {
    width: '33%',
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  column1: {
    width: '25%',
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '65%'
  },

  table: {
    width: '50%',
    borderWidth: 1,
    borderColor: 'black',
    height: '100%'
  },
  row3: {
    flexDirection: 'row'
  },
  cell: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: 'black',
    fontSize: 8,
    fontFamily: 'Roboto'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf3 = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const ageString = data.age;
  const years = ageString.match(/\d+Y/);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`}>
          <Page size="A4" style={styles.page}>
            <View
              style={{
                fontFamily: 'Roboto',
                fontSize: '20px'
              }}
            >
              <Text content={'Op Slip'} />
            </View>
            <View>
              <View
                style={{
                  ...styles.row,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  top: '60%',
                  left: -80,
                  width: '100%'
                }}
              >
                <Text content={'Diagnosis:'} />
              </View>
              <View
                style={{
                  ...styles.row,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  top: '70%',
                  left: -80,
                  width: '100%'
                }}
              >
                <Text content={'TREATEMENT ADVICE:'} />
              </View>
              <View
                style={{
                  ...styles.row,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  top: '115%',
                  left: -80
                }}
              >
                <Text content={'FOLLOW UP ADVICE:'} />
              </View>
              <View
                style={{
                  ...styles.row,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  top: '120%',
                  right: -150
                }}
              >
                <Text content={'Signature of the Doctor:'} />
              </View>
              <View
                style={{
                  ...styles.row,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  top: '55%',
                  left: -210
                }}
              >
                <Text content={'FINDINGS:'} />
              </View>
              <View
                style={{
                  ...styles.row,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  top: '75%',
                  left: -210
                }}
              >
                <Text content={'INVESTIGATIONS'} />
              </View>
            </View>
            <View></View>
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Patient Name    :           " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={data.name} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Gender       :           " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={`${data.age}${data.gender}`} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Next To Kin        :         " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={data?.guardian_name} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Visit Id                :        " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={data?.op_no} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Mobile No          :      " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={data.mobile} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Address             :      " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={data.address} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Sponsor             :    " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={data.sponsor} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text content="Opd Fees            :    " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text content={data.opd_fee} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
              </View>

              <View style={styles.column}>
                <View style={styles.row}>
                  <Text
                    content="UhidNo                    :                          "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text content={`${data.uhid}`} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Doctor Name          :                       "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text content={`${data.consultant}`} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Department Name :                      "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text content={data.department} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Unit                           :                     "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text content={data.unit} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Registered Date      :                   "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text
                    content={`${formatDate(data.reg_date)} ${data?.reg_time}`}
                    style={{ ...styles.value, textAlign: 'start' }}
                  />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Token No.                 :                    "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text content={data.token_no} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Payment Type          :                    "
                    style={{ ...styles.label, fontFamily: 'Roboto' }}
                  />
                  <Text content={data.pay_type} style={{ ...styles.value, textAlign: 'start' }} />
                </View>
              </View>
            </View>
            <View style={styles.contentContainer1}>
              <View style={styles.row}>
                <Text content={'Complaints'} style={{ ...styles.text, fontFamily: 'Roboto', textAlign: 'start' }} />
              </View>
              <View
                style={{
                  ...styles.table,
                  fontFamily: 'Roboto',
                  position: 'relative',
                  right: -220
                }}
              >
                <View style={styles.row3}>
                  <Text style={styles.cell} content="BP" />
                  <Text style={styles.cell} />
                  <Text style={styles.cell} content="HEIGHT" />
                  <Text style={styles.cell} />
                </View>
                <View style={styles.row3}>
                  <Text style={styles.cell} content="PULSE" />
                  <Text style={styles.cell} />
                  <Text style={styles.cell} content="WEIGHT" />
                  <Text style={styles.cell} />
                </View>
                <View style={styles.row3}>
                  <Text style={styles.cell} content="TEMP" />
                  <Text style={styles.cell} />
                  <Text style={styles.cell} content="BMI" />
                  <Text style={styles.cell} />
                </View>
              </View>
            </View>

            <View
              style={{
                ...styles,
                width: '100%'
              }}
            >
              <View style={{ ...styles.column1, borderRight: '1px solid black', padding: '6px', height: '97%' }}></View>
            </View>
            <View style={{ ...styles.contentContainer3 }}>
              <View style={{ ...styles.row }}>
                <Text
                  style={{ textAlign: 'center' }}
                  content={'OPD Timing : 10am to 6pm Mon-Sat & Closed on Sunday(24*7 Emergency)'}
                />
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
